<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterCustomerLicensePlateMapping"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field v-model="filterCustomerLicensePlateMapping.LicensePlate" label="車牌" />
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getCustomerLicensePlateMapping">
              {{ $t('common_search') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="customerLicensePlateMappingDataTableHeaders"
      :items="customerLicensePlateMappingList"
      class="elevation-1 mt-2"
      :loading="isLoadingCustomerLicensePlateMapping"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>客戶車牌Mapping表</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:[`item.IsDeactivate`]="{ item }">
        <v-chip :color="item.IsDeactivate ? 'red' : 'green'" dark>
          {{ item.IsDeactivate ? '是' : '否' }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpCustomerLicensePlateMapping } from '@/js/http-Manager'
import CustomerAutocompleteFilter from '../components/CustomerAutocompleteFilter.vue'

export default {
  components: { CustomerAutocompleteFilter },
  name: 'CustomerLicensePlateMapping',
  data: () => ({
    customerLicensePlateMappingList: [],
    searchCustomerLicensePlateMapping: '',
    isLoadingCustomerLicensePlateMapping: true,
    updateItemSource: null,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    filterCustomerLicensePlateMapping: {
      LicensePlate: '',
      CustomerId: ''
    }
  }),
  async mounted () {
    await this.getCustomerLicensePlateMapping()
    await this.getTotalCount()
  },
  computed: {
    customerLicensePlateMappingDataTableHeaders () {
      return [
        {
          text: '客戶代號',
          align: 'start',
          value: 'CustomerNumber'
        },
        {
          text: '客戶簡稱',
          align: 'start',
          value: 'CustomerShortName'
        },
        {
          text: '客戶全名',
          align: 'start',
          value: 'CustomerFullName'
        },
        {
          text: '車牌',
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: '是否停用',
          align: 'start',
          value: 'IsDeactivate'
        }
      ]
    }
  },
  methods: {
    setFilterCustomer (val) {
      this.filterCustomerLicensePlateMapping.CustomerId = val.Id
      this.filterCustomerLicensePlateMapping.CustomerNumber = val.Number
      this.filterCustomerLicensePlateMapping.CustomerName = val.ShortName
      this.filterCustomerLicensePlateMapping.CustomerFullName = val.FullName
      this.filterCustomerLicensePlateMapping = JSON.parse(
        JSON.stringify(this.filterCustomerLicensePlateMapping)
      )
    },
    async getTotalCount () {
      if (this.isUpdateEventTotal) {
        let param = {
          CustomerId: this.filterCustomerLicensePlateMapping.CustomerId,
          LicensePlate: this.filterCustomerLicensePlateMapping.LicensePlate
        }
        let response = await HttpCustomerLicensePlateMapping.GetCustomerLicensePlateMappingCount(
          param
        )
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getCustomerLicensePlateMapping(val)
    },
    async getCustomerLicensePlateMapping (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        await this.getTotalCount()
      }
      this.isUpdateEventTotal = true
      this.isLoadingCustomerLicensePlateMapping = true
      let param = {
        CustomerId: this.filterCustomerLicensePlateMapping.CustomerId,
        LicensePlate: this.filterCustomerLicensePlateMapping.LicensePlate,
        ItemsPerPage: val && val.itemsPerPage ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: val && val.page ? val.page : this.currentOptions.page,
        SortBy: val && val.sortBy ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: val && val.sortDesc ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }
      let response = await HttpCustomerLicensePlateMapping.GetCustomerLicensePlateMappingDataTable(
        param
      )
      this.isLoadingCustomerLicensePlateMapping = false
      this.customerLicensePlateMappingList =
        response && response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    }
  }
}
</script>
